import React, { useState } from "react";
// @ts-ignore
import 'swiper/css';
// @ts-ignore
import 'swiper/css/pagination';
// @ts-ignore
import 'swiper/css/navigation';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';

import isMobileDevice from "../controllers/checkMobile.controller";

import Header from "../components/header";
import Footer from "../components/footer";
import { GradeLivre, GradeTotal } from "../components/grade";

import logoImg from "../img/header-logo.svg";
import logo2kplay from "../img/logo-2kplay.svg";
import logo2kmovel from "../img/logo-2kmovel.svg";

import dispositivosImg from "../img/dispositivos.svg";
import doubleCheckImg from "../img/double-ckeck.svg";

// Ícones de canais 
import aparecidaImg from "../img/canais/aparecida.svg";
import bandSportsImg from "../img/canais/band-sports.svg";
import bandImg from "../img/canais/band.svg";
import combateImg from "../img/canais/combate.svg"; 
import culturaImg from "../img/canais/cultura.svg";
import discoveryImg from "../img/canais/discovery.svg";
import discoveryKidsImg from "../img/canais/discoveryKids.svg";
import globoImg from "../img/canais/globo.svg";
import hboImg from "../img/canais/hbo.svg";
import multishowImg from "../img/canais/multishow.svg";
import premiereImg from "../img/canais/premiere.svg";
import recordImg from "../img/canais/record.svg";
import redetvImg from "../img/canais/redetv.svg";
import sbtImg from "../img/canais/sbt.svg";
import sexpriveImg from "../img/canais/sexprive.svg";
import sportvImg from "../img/canais/sportv.svg";
import telecineImg from "../img/canais/telecine.svg";

// Cards Planos Móveis
import plan10gbImg from "../img/mobile-plans/10gb.svg";
import plan15gbImg from "../img/mobile-plans/15gb.svg";
import plan20gbImg from "../img/mobile-plans/20gb.svg";
import plan30gbImg from "../img/mobile-plans/30gb.svg";
import plan40gbImg from "../img/mobile-plans/40gb.svg";
import plan50gbImg from "../img/mobile-plans/50gb.svg";

// Cards Planos Fixos
import fixPlanBasicImg from "../img/fix-plan-basic.svg";
import fixPlanPlusImg from "../img/fix-plan-plus.svg";

// Overlay backgrounds
import OvBgDestImg from "../img/bg-destaque.svg";
import movieRightImg from "../img/movie-right.svg";

import "../style/home.css";
import Whatsapp from "../components/whatsapp";

function Home() {
    const [ popupclosed, setPopupClosed ] = useState(true);
    const [ gradeType, setGradeType ] = useState("livre");

    return (
        <React.Fragment>
            <div className="main-container">
                <Header />
                <div className="top-banner-container">
                    <div className="text-wrapper">
                        <b>Bem-vindo à 2K20!</b>
                        <span>A TV por streaming e a telefonia que <br />cabem na sua mão e no seu bolso!</span>
                        <a href="https://conta.2k20.com.br/">Assinar agora!</a>
                    </div>
                </div>
            </div>

            <div className="plans-destaque-container" id="dest">
                <div className="destaque-header">
                    <img src={logo2kplay} alt="" className="logo-image" />
                    <b>Assista do seu jeito</b>
                    <span>São mais de 100 canais ao vivo, filmes e séries pra maratonar sem limites. Tem na sua smart TV, no celular, no tablet e no PC.</span>
                </div>
                <div className="destaque-content">
                    <img src={dispositivosImg} alt="" className="destaque-img" />
                    <div className="separator">
                        <Swiper slidesPerView={1} autoplay={false} spaceBetween={30} loop={true} navigation={true} modules={[Navigation, Autoplay]} className="destaque-plans">
                            <SwiperSlide>
                                <div className="plan-item">
                                    <b className="plan-header">Plano <br />livre</b>
                                    <hr />
                                    <div className="benefits-wrapper">
                                        <div className="benefit">
                                            <img src={doubleCheckImg} alt="" className="check" />
                                            <span>Mais de 40 canais</span>
                                        </div>
                                        <div className="benefit">
                                            <img src={doubleCheckImg} alt="" className="check" />
                                            <span>Filmes e séries sob demanda</span>
                                        </div>
                                        <div className="benefit">
                                            <img src={doubleCheckImg} alt="" className="check" />
                                            <span>Voltar conteúdo ao vivo</span>
                                        </div>
                                        <div className="benefit">
                                            <img src={doubleCheckImg} alt="" className="check" />
                                            <span>Até 3 dispositivos simultâneos</span>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="price-wrapper">
                                        <span>R$</span>
                                        <span className="dest">19</span>
                                        <span>,90</span>
                                    </div>
                                    <a href="https://conta.2k20.com.br/">
                                        Assinar plano
                                    </a>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="plan-item">
                                    <b className="plan-header">Plano <br />total</b>
                                    <hr />
                                    <div className="benefits-wrapper">
                                        <div className="benefit">
                                            <img src={doubleCheckImg} alt="" className="check" />
                                            <span>Mais de 100 canais</span>
                                        </div>
                                        <div className="benefit">
                                            <img src={doubleCheckImg} alt="" className="check" />
                                            <span>Filmes e séries ilimitados</span>
                                        </div>
                                        <div className="benefit">
                                            <img src={doubleCheckImg} alt="" className="check" />
                                            <span>Voltar conteúdo ao vivo</span>
                                        </div>
                                        <div className="benefit">
                                            <img src={doubleCheckImg} alt="" className="check" />
                                            <span>Até 5 dispositivos simultâneos</span>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="price-wrapper">
                                        <span>R$</span>
                                        <span className="dest">99</span>
                                        <span>,90</span>
                                    </div>
                                    <a href="https://conta.2k20.com.br/">
                                        Assinar plano
                                    </a>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                        <button title="Grades de Canais" className="grades-link"  onClick={() => setPopupClosed(!popupclosed)}>
                            <span>Confira a lista de canais!</span>
                            <svg height="14" viewBox="0 0 27 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.756 0.387986C16.2247 0.919273 16.2247 1.77751 16.756 2.30879L22.028 7.60804L1.36232 7.60805C0.613065 7.60805 4.08656e-05 8.22107 4.09311e-05 8.97032C4.09966e-05 9.71957 0.613065 10.3326 1.36232 10.3326L22.028 10.3326L16.7424 15.6182C16.2111 16.1495 16.2111 17.0077 16.7424 17.539C17.2737 18.0703 18.1319 18.0703 18.6632 17.539L26.292 9.92391C26.8233 9.39263 26.8233 8.53439 26.292 8.0031L18.6768 0.387985C18.1456 -0.129679 17.2737 -0.129679 16.756 0.387986Z" fill="white"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            
            <img src={OvBgDestImg} alt="" className="over-bg-destaque" />
            <img src={movieRightImg} alt="" className="over-movie" />

            <div className="canais-container">
                <b>Grade de canais <span>Plano Livre</span></b>
                <div className="lista-canais">
                    <Swiper slidesPerView={'auto'} spaceBetween={30} loop={true} freeMode={true} autoplay={{ delay: 0, disableOnInteraction: false }} speed={4000} modules={[Navigation, Autoplay]} className="canais-swiper" >

                        {[...Array(3)].map((_, i) => (
                            <React.Fragment key={i}>
                                <SwiperSlide key={i} style={{ width: "100px" }}>
                                    <img src={recordImg} alt="" className="canal-img" />
                                </SwiperSlide>
                                <SwiperSlide key={i} style={{ width: "100px" }}>
                                    <img src={globoImg} alt="" className="canal-img" />
                                </SwiperSlide>
                                <SwiperSlide key={i} style={{ width: "100px" }}>
                                    <img src={redetvImg} alt="" className="canal-img" />
                                </SwiperSlide>
                                <SwiperSlide key={i} style={{ width: "100px" }}>
                                    <img src={sbtImg} alt="" className="canal-img" />
                                </SwiperSlide>
                                <SwiperSlide key={i} style={{ width: "100px" }}>
                                    <img src={bandImg} alt="" className="canal-img" />
                                </SwiperSlide>
                                <SwiperSlide key={i} style={{ width: "100px" }}>
                                    <img src={aparecidaImg} alt="" className="canal-img" />
                                </SwiperSlide>
                                <SwiperSlide key={i} style={{ width: "100px" }}>
                                    <img src={culturaImg} alt="" className="canal-img" />
                                </SwiperSlide>
                            </React.Fragment>
                        ))}
                    </Swiper>
                </div>

                <b>Grade de canais <span>Plano Total</span></b>

                <div className="lista-canais">
                    <Swiper slidesPerView={'auto'} spaceBetween={50} loop={true} freeMode={true} autoplay={{ delay: 0, disableOnInteraction: false, reverseDirection: true }}  speed={4000} modules={[Navigation, Autoplay]} className="canais-swiper">

                        {[...Array(7)].map((_, i) => (
                            <React.Fragment key={i}>
                                <SwiperSlide key={i} style={{ width: "100px" }}>
                                    <img src={discoveryImg} alt="" className="canal-img" />
                                </SwiperSlide>
                                <SwiperSlide key={i} style={{ width: "100px" }}>
                                    <img src={discoveryKidsImg} alt="" className="canal-img" />
                                </SwiperSlide>
                                <SwiperSlide key={i} style={{ width: "100px" }}>
                                    <img src={bandSportsImg} alt="" className="canal-img" />
                                </SwiperSlide>
                                <SwiperSlide key={i} style={{ width: "100px" }}>
                                    <img src={multishowImg} alt="" className="canal-img" />
                                </SwiperSlide>
                                <SwiperSlide key={i} style={{ width: "100px" }}>
                                    <img src={sportvImg} alt="" className="canal-img" />
                                </SwiperSlide>
                            </React.Fragment>
                        ))}
                    </Swiper>
                </div>

                <b>Nossos canais <br /> <span>adicionais</span></b>
                <div className="la-carte-grid">
                    <Swiper slidesPerView={isMobileDevice() ? 1 : 3} autoplay={{ delay: 2500, disableOnInteraction: false }} spaceBetween={30} loop={true} navigation={true} modules={[Navigation, Autoplay]} className="mySwiper">
                        <SwiperSlide>
                            <div className="la-carte-item">
                                <img src={telecineImg} alt="item-img" className="item-img" />
                                <span className="desc">Canais Telecine</span>
                                <div className="price">
                                    <span>R$</span>
                                    <span className="dest">29</span>
                                    <span>,90</span>
                                </div>
                                <button onClick={() => {window.location.href = "https://conta.2k20.com.br/"}}>Assinar</button>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="la-carte-item">
                                <img src={premiereImg} alt="item-img" className="item-img" />
                                <span className="desc">Canais Premiere</span>
                                <div className="price">
                                    <span>R$</span>
                                    <span className="dest">59</span>
                                    <span>,90</span>
                                </div>
                                <button onClick={() => {window.location.href = "https://conta.2k20.com.br/"}}>Assinar</button>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="la-carte-item">
                                <img src={combateImg} alt="item-img" className="item-img" />
                                <span className="desc">Combate</span>
                                <div className="price">
                                    <span>R$</span>
                                    <span className="dest">34</span>
                                    <span>,90</span>
                                </div>
                                <button onClick={() => {window.location.href = "https://conta.2k20.com.br/"}}>Assinar</button>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="la-carte-item">
                                <img src={hboImg} alt="item-img" className="item-img" />
                                <span className="desc">Canais HBO</span>
                                <div className="price">
                                    <span>R$</span>
                                    <span className="dest">28</span>
                                    <span>,90</span>
                                </div>
                                <button onClick={() => {window.location.href = "https://conta.2k20.com.br/"}}>Assinar</button>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="la-carte-item">
                                <img src={sexpriveImg} alt="item-img" className="item-img" />
                                <span className="desc">Sex Privê</span>
                                <div className="price">
                                    <span>R$</span>
                                    <span className="dest">29</span>
                                    <span>,90</span>
                                </div>
                                <button onClick={() => {window.location.href = "https://conta.2k20.com.br/"}}>Assinar</button>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>

            <div className="mobile-plans-container" id="mobile">
                <img src={logo2kmovel} className="logo" />
                <b>Aproveite nossos planos <br />de telefonia móvel</b>

                <Swiper
                    slidesPerView={isMobileDevice() ? 1 : 5}
                    spaceBetween={0}
                    centeredSlides={true}
                    loop={true}
                    autoplay={false}
                    navigation={true}
                    modules={[Navigation, Autoplay]}
                    className="mobile-plans-wrapper">
                        {[...Array(5)].map((_, i) => (
                            <React.Fragment>
                                <SwiperSlide>
                                    <a href="https://conta.2k20.com.br/" className="plan-link">
                                        <img src={plan10gbImg} alt="" className="plan-card" />
                                    </a>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <a href="https://conta.2k20.com.br/" className="plan-link">
                                        <img src={plan15gbImg} alt="" className="plan-card" />
                                    </a>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <a href="https://conta.2k20.com.br/" className="plan-link">
                                        <img src={plan20gbImg} alt="" className="plan-card" />
                                    </a>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <a href="https://conta.2k20.com.br/" className="plan-link">  
                                        <img src={plan30gbImg} alt="" className="plan-card" />
                                    </a>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <a href="https://conta.2k20.com.br/" className="plan-link">
                                        <img src={plan40gbImg} alt="" className="plan-card" />
                                    </a>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <a href="https://conta.2k20.com.br/" className="plan-link">
                                        <img src={plan50gbImg} alt="" className="plan-card" />
                                    </a>
                                </SwiperSlide>  
                            </React.Fragment>
                        ))}
                </Swiper>
            </div>

            <div className="enterprise-plan-container">
                <div className="text-wrapper">
                    <b>Planos 2KMÓVEL para sua empresa</b>
                    <span>Sua empresa sempre conectada com planos de alta velocidade e ligações ilimitadas. Mais economia, praticidade e suporte dedicado para o seu negócio crescer sem interrupções.</span>
                    <a href="http://wa.me/+552122000888" target="_blank" rel="noreferrer">Entre em contato</a>
                </div>
            </div>

            <div className="fix-plans-container" id="fix">
                <div className="text-wrapper">
                    <b>Telefone fixo ainda <br />faz sentido!</b>
                    <span>Ligações pra qualquer operadora <br />do Brasil. Ótima opção para <br />empresas e famílias que ainda <br />utilizam fixo.</span>
                </div>

                 <Swiper slidesPerView={1} autoplay={false} spaceBetween={30} loop={true} navigation={true} modules={[Navigation, Autoplay]} className="cards-wrapper">
                    <SwiperSlide>
                        <a href="https://conta.2k20.com.br/">
                            <img src={fixPlanBasicImg} alt="" className="plan-card" />
                        </a>
                    </SwiperSlide>

                    <SwiperSlide>
                        <a href="https://conta.2k20.com.br/">
                            <img src={fixPlanPlusImg} alt="" className="plan-card" />
                        </a>
                    </SwiperSlide>
                 </Swiper>
            </div>

            <div className="infomercial-container" id="about">
                <div className="text-wrapper">
                    <img src={logoImg} alt="" className="logo" />
                    <div className="text">
                        <span>A <b>2K20</b> é mais do que uma empresa de TV e telefonia. Somos o resultado da evolução tecnológica no setor de telecomunicações, criados com o propósito de simplificar e tornar mais transparente o acesso a serviços essenciais de comunicação e entretenimento.</span>
                        <span><b>Nosso propósito:</b> Descomplicar para Conectar. Acreditamos que a tecnologia deve facilitar a vida das pessoas. Por isso, nossa missão é oferecer uma experiência simples, justa e totalmente digital, baseada em três pilares:</span>
                        <span><b>Simplicidade:</b> eliminamos burocracias e termos complexos.</span>
                        <span><b>Transparência:</b> sem letras miúdas, fidelidade ou cobranças inesperadas.</span>
                        <span><b>Liberdade:</b> o cliente escolhe o que precisa, com flexibilidade para mudar a qualquer momento.</span>
                        <b>Experiência 100% digital</b>
                        <span>A 2K20 integra TV e telefonia em uma plataforma moderna, intuitiva e acessível. Da escolha do plano à ativação do serviço, todo o processo é feito online, de forma rápida e segura. Em poucos cliques, o cliente tem acesso imediato à melhor experiência em conectividade e entretenimento.</span>
                    </div>
                </div>

                <div className="info-img"></div>
            </div>

            <div className={popupclosed ? "popup-grade hidden" : "popup-grade"}>
                <div className="grade-wrapper">
                    <div className="title-wrapper">
                        <b className="title">Grade de Canais</b>
                    </div>
                    <div className="buttons">
                        <button className={gradeType === "livre" ? "grade-button active" : "grade-button"} onClick={() => setGradeType("livre")}>
                            <img src={logo2kplay} alt="" />
                            <span>Livre</span>
                        </button>
                        <button className={gradeType === "total" ? "grade-button active" : "grade-button"} onClick={() => setGradeType("total")}>
                            <img src={logo2kplay} alt="" />
                            <span>Total</span>
                        </button>

                    </div>
                    {
                        gradeType === "livre" ? <GradeLivre /> : <GradeTotal />
                    }
                    <button className="close" onClick={() => setPopupClosed(!popupclosed)}>Fechar</button>
                </div>
            </div>
            
            <Whatsapp/>
            <Footer />
        </React.Fragment>
    )
}

export default Home;